import { css } from '@emotion/react';

export const root = css`
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  background-color: var(--gray-3);
`;

export const button = css`
  margin-top: 8px;
`;
